<section class="landing-shell">
  <canvas ref="particleCanvas" class="landing-particles" aria-hidden="true"></canvas>

  <div class="landing-layout">
    <NavbarSection />
    <HeroSection />
  </div>
</section>
